import React, { Component } from 'react'

export default class LinksUseful extends Component {
  render() {
    return (
      <div className='links-useful'>
        <a href="#">Try Live for free</a>
        <a href="#">Log in or register</a>
      </div>
    )
  }
}
